export const getFnbDashboardData = async (data, thunkApi) => {
  try {
    const { user } = thunkApi.extra.apiService;
    const { store, terminal, search, sort, limit, offset, pricerange, breakup, month, year } = data;
    const response = await user.get("/fnbproduct", {
      params: {
        store,
        terminal,
        search,
        sort,
        limit,
        offset,
        pricerange,
        breakup,
        month,
        year,
      },
    });

    return response;
  } catch (error) {
    return new Promise.reject(error);
  }
};
